// extracted by mini-css-extract-plugin
export var linkText = "_pq-0";